import React from 'react'
import ChangelogVersion from './ChangelogVersion'
import {
  ChangelogVersion as ChangelogVersionType,
  ChangelogFilter,
} from '../types'

interface ChangelogListProps {
  list: ChangelogVersionType[]
  filter: ChangelogFilter
}

const ChangelogList: React.FC<ChangelogListProps> = React.memo(
  ({ list, filter }) => {
    // Will override filters if all of them are false
    const empty = !filter.improvement && !filter.feature && !filter.fix

    return (
      <div className="changelog-items pb-8" style={{ paddingBottom: '2rem' }}>
        {list &&
          list.length > 0 &&
          list.map(
            ({ version, date, fixes, features, improvements }, index) => (
              <ChangelogVersion
                key={`${version}-${index}`}
                version={version}
                date={date}
                fixes={(empty || filter.fix) && fixes}
                features={(empty || filter.feature) && features}
                improvements={(empty || filter.improvement) && improvements}
              />
            ),
          )}
      </div>
    )
  },
)

export default ChangelogList
